// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { TenancyAnniversaryWithTenancyDTO } from '../models';
/**
 * TenancyAnniversariesApi - axios parameter creator
 * @export
 */
export const TenancyAnniversariesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get all tenancy anniversaries for a tenancy by tenancy id
         * @param {string} tenancyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyAnniversaries(tenancyId: string, options: any = {}): RequestArgs {
            // verify required parameter 'tenancyId' is not null or undefined
            if (tenancyId === null || tenancyId === undefined) {
                throw new RequiredError('tenancyId','Required parameter tenancyId was null or undefined when calling getTenancyAnniversaries.');
            }
            const localVarPath = `/v2/tenancies/{tenancyId}/anniversaries`
                .replace(`{${"tenancyId"}}`, encodeURIComponent(String(tenancyId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenancyAnniversariesApi - functional programming interface
 * @export
 */
export const TenancyAnniversariesApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get all tenancy anniversaries for a tenancy by tenancy id
         * @param {string} tenancyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyAnniversaries(tenancyId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TenancyAnniversaryWithTenancyDTO>> {
            const localVarAxiosArgs = TenancyAnniversariesApiAxiosParamCreator(configuration).getTenancyAnniversaries(tenancyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TenancyAnniversariesApi - factory interface
 * @export
 */
export const TenancyAnniversariesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Get all tenancy anniversaries for a tenancy by tenancy id
         * @param {string} tenancyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getTenancyAnniversaries(tenancyId: string, options?: any) {
            return TenancyAnniversariesApiFp(configuration).getTenancyAnniversaries(tenancyId, options)(axios, basePath);
        },
    };
};

/**
 * TenancyAnniversariesApi - interface
 * @export
 * @interface TenancyAnniversariesApi
 */
export interface TenancyAnniversariesApiInterface {
    /**
     * Get all tenancy anniversaries for a tenancy by tenancy id
     * @param {string} tenancyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyAnniversariesApiInterface
     */
    getTenancyAnniversaries(tenancyId: string, options?: any): AxiosPromise<Array<TenancyAnniversaryWithTenancyDTO>>;

}

/**
 * TenancyAnniversariesApi - object-oriented interface
 * @export
 * @class TenancyAnniversariesApi
 * @extends {BaseAPI}
 */
export class TenancyAnniversariesApi extends BaseAPI implements TenancyAnniversariesApiInterface {
    /**
     * Get all tenancy anniversaries for a tenancy by tenancy id
     * @param {string} tenancyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyAnniversariesApi
     */
    public getTenancyAnniversaries(tenancyId: string, options?: any) {
        return TenancyAnniversariesApiFp(this.configuration).getTenancyAnniversaries(tenancyId, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for TenancyAnniversariesApi
 * Import individual functions for optimal bundle size
 */
/**
 * Get all tenancy anniversaries for a tenancy by tenancy id
 * @param {string} tenancyId 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getTenancyAnniversaries(
    tenancyId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<TenancyAnniversaryWithTenancyDTO>> {
    const localVarAxiosArgs = TenancyAnniversariesApiAxiosParamCreator(configuration).getTenancyAnniversaries(tenancyId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

